import React from 'react'
import styled from 'styled-components'

const StyledCheckboxWrapper = styled.div`
  display: ${({ checkbox }) => (checkbox ? 'flex' : 'none')};
  justify-content: center;
  padding: 16px 0;
  text-align: center;
  width: 100%;

  input {
    & ~ .check-toggle {
      border-radius: 4px;
      border: 2px solid #c9ced6;
      cursor: pointer;
      display: inline-block;
      height: 20px;
      margin-right: 8px;
      position: relative;
      vertical-align: middle;
      width: 20px;
    }

    &:checked {
      & ~ .check-toggle {
        background: url('data:image/svg+xml;base64,CgoKPHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgICA8ZGVmcz4KICAgICAgICA8cGF0aCBpZD0iYSIgZD0iTTUuODQ2IDJoMTIuMzA4YzEuMzM3IDAgMS44MjIuMTQgMi4zMTEuNC40OS4yNjIuODczLjY0NiAxLjEzNCAxLjEzNS4yNjIuNDg5LjQwMS45NzQuNDAxIDIuMzF2MTIuMzFjMCAxLjMzNi0uMTQgMS44MjEtLjQgMi4zMWEyLjcyNiAyLjcyNiAwIDAgMS0xLjEzNSAxLjEzNGMtLjQ4OS4yNjItLjk3NC40MDEtMi4zMS40MDFINS44NDRjLTEuMzM2IDAtMS44MjEtLjE0LTIuMzEtLjRBMi43MjYgMi43MjYgMCAwIDEgMi40IDIwLjQ2NGMtLjI2Mi0uNDg5LS40MDEtLjk3NC0uNDAxLTIuMzFWNS44NDRjMC0xLjMzNi4xNC0xLjgyMS40LTIuMzFBMi43MjYgMi43MjYgMCAwIDEgMy41MzYgMi40QzQuMDI0IDIuMTM5IDQuNTA5IDIgNS44NDUgMnoiLz4KICAgIDwvZGVmcz4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPG1hc2sgaWQ9ImIiIGZpbGw9IiNmZmYiPgogICAgICAgICAgICA8dXNlIHhsaW5rOmhyZWY9IiNhIi8+CiAgICAgICAgPC9tYXNrPgogICAgICAgIDxwYXRoIHN0cm9rZT0iUkdCQSgxOTIsMzYsNDAsMC41MSkiIHN0cm9rZS13aWR0aD0iMiIgZD0iTTUuODQ2IDNjLTEuMDY4IDAtMS40NDkuMDczLTEuODQuMjgzLS4zMTQuMTY4LS41NTUuNDA5LS43MjMuNzIzLS4yMS4zOTEtLjI4My43NzItLjI4MyAxLjg0djEyLjMwOGMwIDEuMDY4LjA3MyAxLjQ0OS4yODMgMS44NC4xNjguMzE0LjQwOS41NTUuNzIzLjcyMy4zOTEuMjEuNzcyLjI4MyAxLjg0LjI4M2gxMi4zMDhjMS4wNjggMCAxLjQ0OS0uMDczIDEuODQtLjI4My4zMTQtLjE2OC41NTUtLjQwOS43MjMtLjcyMy4yMS0uMzkxLjI4My0uNzcyLjI4My0xLjg0VjUuODQ2YzAtMS4wNjgtLjA3My0xLjQ0OS0uMjgzLTEuODRhMS43MjYgMS43MjYgMCAwIDAtLjcyMy0uNzIzYy0uMzkxLS4yMS0uNzcyLS4yODMtMS44NC0uMjgzSDUuODQ2eiIvPgogICAgICAgIDxwYXRoIGZpbGw9IiNjMDI0MjgiIGQ9Ik0xNS4zMTQgOC43OTNhMSAxIDAgMSAxIDEuNDE0IDEuNDE0bC02IDZhMSAxIDAgMCAxLTEuNDE0IDBsLTIuNTIxLTIuNTIxYTEgMSAwIDEgMSAxLjQxNC0xLjQxNGwxLjgxNCAxLjgxNCA1LjI5My01LjI5M3oiIG1hc2s9InVybCgjYikiLz4KICAgIDwvZz4KPC9zdmc+')
          center no-repeat;
        border: 2px solid transparent;
      }
    }
  }
`

const StyledLabel = styled.label`
  color: ${({ theme }) => theme.colors.greyParagraphColor};
  cursor: pointer;
  font-size: 0.875em;
  line-heigth: 1.71;
`

const Checkbox = ({ cmsData, checkbox, id, text, name, onChange, value, required }) => {
  return (
    <StyledCheckboxWrapper checkbox={cmsData ? cmsData.checkbox : checkbox}>
      <StyledLabel htmlFor={id}>
        <input
          autoComplete="off"
          id={id}
          name={name}
          onChange={onChange}
          required={required}
          type="checkbox"
        />
        <span className="check-toggle" />
        {text}
      </StyledLabel>
    </StyledCheckboxWrapper>
  )
}

export default Checkbox